import { InjectionToken } from '@angular/core';

// TODO: consumption of inventories api should move to GQL layer, currently only c-basket is consuming it
export const INVENTORIES_API_TOKEN = new InjectionToken<string>(
  'Inventories API url',
);
